import { React } from '_core';

import DataGrid from './data-grid';
import { ProviderProps, RegularDataGridContextProvider } from './regular-context';

const RegularDataGrid = (props: ProviderProps) => {
  return (
    <RegularDataGridContextProvider {...props}>
      <DataGrid />
    </RegularDataGridContextProvider>
  );
};

export default RegularDataGrid;
